<template>
	<div>
		<el-dialog title="检测到升级中断" :visible="NOTLINKEDSTATUS" width="392px" :show-close="false" :close-on-click-modal="false">
			<div class="tip flexJA flexFs">
				<img src="@/assets/images/33.png">
				<div>请插入耳机后，点击确认恢复升级。<br/>若不能继续升级请重启电脑后再试。</div>
			</div>
			<div class="btns flexJA">
				<div class="btn btn-1 flexJA" @click="confirm">确认</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import { Loading } from 'element-ui';
	export default {
		data() {
			return {
				num: 0,
				times: null,
				elLoading: null,
				Progress: 0,
			}
		},
		computed: {
			...mapState({
				NOTLINKEDSTATUS: (state) => state.NOTLINKEDSTATUS,
			}),
		},
		methods: {
			confirm() {
				this.elLoading = this.$loading({
					lock: true,
					text: '检测升级进度...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 1)'
				});
				window.LZPlugin.nativeCall("IAPBurner.dll","GetProgress",null).then(res=>{
					this.Progress = res.msg;
					console.log('第一次进度：', this.Progress)
					if(res.msg != 100) {
						this.times = setInterval(e=>{
							this.GetProgress();
							// this.GetDeviceStatus();
						}, 1000)
					}else {
						console.log('进度为100，就不弹出升级界面面了')
						localStorage.removeItem('UpgradeData');
						this.elLoading && this.elLoading.close();
						this.$store.commit('gotState', {key: 'NOTLINKEDSTATUS', data: false});
						// this.$message({ message: '已升级成功！', type: 'success' });
						this.$store.commit('setUpgrade', {status: true, progress: 100, dialogStatus: true, type: 3});
					}
				})
			},
			GetDeviceStatus() {
				window.LZPlugin.nativeCall("LenovoHeadset.dll","GetDeviceStatus",null).then(res=>{
					console.log('LenovoHeadset.dll[GetDeviceStatus]: ', res);
					this.num = this.num + 1;
					if(res.msg == "AT_DEVICE_LINKED") {
						if(this.num > 2) {
							clearInterval(this.times)
							this.elLoading && this.elLoading.close();
							this.GetProgress();
						}
					}else {
						console.log(this.num)
						if(this.num > 10) {
							clearInterval(this.times)
							this.num = 0;
							this.elLoading && this.elLoading.close();
							this.$message({ message: '未监听到设备', type: 'warning' });
						}
					}
				})
				
			},
			GetProgress() {
				window.LZPlugin.nativeCall("IAPBurner.dll","GetProgress",null).then(res=>{
					let Progress = this.Progress;
					console.log('第二次进度：', res.msg)
					clearInterval(this.times)
					this.elLoading && this.elLoading.close();
					this.$store.commit('gotState', {key: 'NOTLINKEDSTATUS', data: false});
					if(res.msg == 100) {
						console.log('进度为100，就不弹出升级界面面了')
						localStorage.removeItem('UpgradeData')
						this.$store.commit('setUpgrade', {status: true, progress: 100, dialogStatus: true, type: 3});
					}else {
						console.log('第一次获取进度：', Progress, '第二次获取进度：', res.msg )
						if(res.msg == Progress) {
							console.log('进度<100，隔500ms再取一次进度，如果两个进度相等，则说明后台没有升级，就弹出画面，让用户升级')
							// 进度<100，就间隔500ms再取一次进度，如果两个进度相等，则说明后台没有升级，就弹出画面，让用户升级。
							this.$store.commit('setUpgrade', {status: true, progress: 0, dialogStatus: true, type: 1});
						}else {
							console.log('进度<100，如果进度不等，则提示用户“升级中，请等待”，直到进度到100，才让用户点击进入里面的功能画面。')
							// 如果进度不等，则提示用户“升级中，请等待”，直到进度到100，才让用户点击进入里面的功能画面。
							this.$store.commit('setUpgrade', {status: true, progress: res.msg, dialogStatus: true, type: 1});
						}
					}
				}).catch(err => {
					console.error('IAPBurner.dll[GetProgress]: ', err)
					setTimeout(e=>{
						this.GetProgress();
					},100)
				});
			}
		}
	}
</script>

<style scoped lang="scss">
	@import '@/assets/css/deep.scss';
</style>